import { render, staticRenderFns } from "./numeric-input.vue?vue&type=template&id=2e822a96&scoped=true&"
import script from "./numeric-input.vue?vue&type=script&lang=js&"
export * from "./numeric-input.vue?vue&type=script&lang=js&"
import style0 from "./numeric-input.vue?vue&type=style&index=0&id=2e822a96&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e822a96",
  null
  
)

export default component.exports